"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parse = require("date-fns/parse");
function pad(number) {
    if (number < 10) {
        return '0' + number.toString();
    }
    return number;
}
function parseDate(rawDate) {
    return parse(rawDate);
}
exports.parseDate = parseDate;
function toShortNotSoISOString(rawDate) {
    var date = parseDate(rawDate);
    return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());
}
exports.toShortNotSoISOString = toShortNotSoISOString;
function toNotSoISOString(rawDate) {
    var date = parseDate(rawDate);
    return date.toISOString().replace(/\..+Z$/, '+0000');
}
exports.toNotSoISOString = toNotSoISOString;
function isValidDate(date) {
    return !isNaN(date.getTime());
}
exports.isValidDate = isValidDate;
//# sourceMappingURL=dates.js.map